// extracted by mini-css-extract-plugin
module.exports = {"contentEnhanced":"style_contentEnhanced__EDAZV","imageWithCaption":"style_imageWithCaption__3_bg3","imageWithCaptionText":"style_imageWithCaptionText__YdiG0 g-type-body-small"};